import { Affix, Button, Card, Form, Space } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import ExportCnfBillForm from "./ExportCnfBillForm";

export default function AddExportCnfBill(props) {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : width ? `${width}px` : "100%"}` }}
        >
          <Header
            title="Add Export C&F Bill"
            subTitle=""
            addLink="/"
            addText=""
            actions={
              <Space>
                <Button
                  danger
                  size="small"
                  onClick={() =>
                    navigate(
                      "/import-export-expense-tracking/external-cnf-bills/export-cnf-bill",
                    )
                  }
                >
                  Discard
                </Button>
                <Button type="primary" size="small" onClick={() => form.submit()}>
                  Save
                </Button>
              </Space>
            }
          />
        </Card>
      </Affix>
      <ExportCnfBillForm form={form} isEdit={false} />
    </>
  );
}
